export const pages = {
  AUTH: '',
  USER_DETAILS: 'עמוד משתמש',
  TRANSFERS_BY_AGENT: 'רשימת העברות',
  INVOICES: 'חשבוניות',
  INVOICE_ORDERS: 'חשבוניות מוזמנות',
  RECEIPTS: 'קבלות',
  CUSTOMERS: 'לקוחות',
  AUTOMATED_PAYMENTS: 'תשלום ביטוח לאומי',
  PARTNERS: 'שותפים',
  UNPAID_AGENTS: 'סוכנים שלא שילמו להם',
  LAW: 'תביעה ייצוגית',
}